<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="table.where" class="ele-form-search ele-table-tool-default" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
      <el-row :gutter="10" style="margin-top: 8px">
        <el-col :md="8" :sm="12">
          <el-form-item>
            <el-input v-model.trim="table.where.studentName" placeholder="请输入姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :md="16" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" size="small" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
            <el-button @click="(table.where = { classId: classId }) && $refs.table.reload()" size="small" icon="el-icon-refresh-left">重置</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 8px">
        <el-col>
          <div class="ele-form-actions">
            <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
            <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除 </el-button>
            <el-button @click="showChangeClass()" type="primary" icon="el-icon-guide" class="ele-btn-icon" size="small">批量调班</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align: center">
      <div style="font-weight: 700; font-size: 17px">{{ title }}</div>
    </div>
    <!-- 数据表格 -->
    <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
      <template #default="{ index }">
        <el-table-column type="selection" width="45" align="center" fixed="left" />
        <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
        <el-table-column prop="studentName" label="姓名" sortable="custom" show-overflow-tooltip align="center" />
        <el-table-column prop="cardNum" label="卡号" sortable="custom" show-overflow-tooltip align="center" />
        <el-table-column label="性别" align="center" show-overflow-tooltip>
          <template #default="{ row }">{{ row.sex == '0' ? '女' : row.sex == '1' ? '男' : '未知' }}</template>
        </el-table-column>
        <el-table-column prop="state" label="状态" sortable="custom" align="center">
          <template #default="{ row }">
            <!--            <el-switch v-model="row.state" @change="editState(row)" :active-value="1" :inactive-value="2"/>-->
            <!--            {{ row.state == '1' ? '接收' : '禁用' }}-->
            <ele-dot
              :type="row.state == '2' ? 'danger' : row.state == '1' ? 'success' : 'info'"
              :ripple="ripple"
              :text="row.state == '2' ? '异常' : row.state == '1' ? '正常' : ''"
              size="10px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip min-width="110" align="center" />
        <el-table-column label="操作" width="230px" align="center" :resizable="false">
          <template #default="{ row }">
            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
            <el-popconfirm title="确定要删除此用户吗？" @onConfirm="remove(row)" class="ele-action">
              <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
            </el-popconfirm>
            <el-link @click="studentMobileDialog(row)" icon="el-icon-mobile" :type="row.yktStudentId == 0 ? 'danger' : 'primary'" :underline="false"
              >学生手机号</el-link
            >
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改用户' : '添加用户'"
      :visible.sync="showEdit"
      width="600px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="用户名:" prop="studentName">
              <el-input v-model="editForm.studentName" placeholder="请输入用户名" clearable />
            </el-form-item>
            <el-form-item label="性别:" prop="sex">
              <el-select v-model="editForm.sex" placeholder="请选择性别" class="ele-block" clearable>
                <el-option label="女" :value="0" />
                <el-option label="男" :value="1" />
                <el-option label="未知" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="学生卡号:" prop="cardNum">
              <el-input v-model="editForm.cardNum" placeholder="请输入学生卡号" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
    <!-- 家长学生手机弹窗 -->
    <el-dialog
      title="学生家长手机号"
      :visible.sync="showStudentMobile"
      width="60%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
      :show-close="false"
    >
      <ele-data-table ref="studentMobileTable" border :data="studentMobileData" :config="studentMobileTable" highlight-current-row>
        <el-table-column type="index" width="45" align="center" />
        <el-table-column label="亲属关系" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-select v-if="$index === editIndex" v-model="editParent.familyRelation" placeholder="请选择亲属关系" class="ele-fluid">
              <el-option label="父亲" value="0" />
              <el-option label="母亲" value="1" />
              <el-option label="爷爷" value="2" />
              <el-option label="奶奶" value="3" />
              <el-option label="姥姥" value="4" />
              <el-option label="姥爷" value="5" />
              <el-option label="哥哥" value="6" />
              <el-option label="姐姐" value="7" />
              <el-option label="其他" value="8" />
            </el-select>
            <span v-else>
              {{
                row.familyRelation == '0'
                  ? '父亲'
                  : row.familyRelation == '1'
                  ? '母亲'
                  : row.familyRelation == '2'
                  ? '爷爷'
                  : row.familyRelation == '3'
                  ? '奶奶'
                  : row.familyRelation == '4'
                  ? '姥姥'
                  : row.familyRelation == '5'
                  ? '姥爷'
                  : row.familyRelation == '6'
                  ? '哥哥'
                  : row.familyRelation == '7'
                  ? '姐姐'
                  : '其他'
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" sortable="custom">
          <template #default="{ row, $index }">
            <el-input v-if="$index === editIndex" v-model="editParent.mobile" placeholder="请输入手机号" />
            <span v-else>{{ row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="运营商" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-select v-if="$index === editIndex" v-model="editParent.netType" placeholder="请选择运营商" class="ele-fluid">
              <el-option label="移动" :value="1" />
              <el-option label="联通" :value="2" />
              <el-option label="电信" :value="3" />
            </el-select>
            <span v-else>
              {{ row.netType == '1' ? '移动' : row.netType == '2' ? '联通' : '电信' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="是否本地" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-select v-if="$index === editIndex" v-model="editParent.netLocal" placeholder="是否本地号码" class="ele-fluid">
              <el-option label="本地" :value="1" />
              <el-option label="异地" :value="0" />
            </el-select>
            <span v-else>
              {{ row.netLocal == '1' ? '本地' : '异地' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" show-overflow-tooltip>
          <template #default="{ row }">
            <div>{{ row.isbilling == 1 ? '正常' : '异常' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250px" align="center" :resizable="false">
          <template #default="{ row, $index }">
            <div v-if="$index === editIndex">
              <el-link @click="onSaveParent(row, $index)" icon="el-icon-check" type="success" :underline="false">保存 </el-link>
              <el-link @click="onCancelParent(row, $index)" icon="el-icon-close" type="warning" :underline="false">取消 </el-link>
            </div>
            <div v-else>
              <el-link @click="onEditParent(row, $index)" icon="el-icon-edit" type="primary" :underline="false">修改 </el-link>
              <span class="ele-action">
                <el-popconfirm title="确定要删除此用户吗？" @onConfirm="onRemoveParent(row, $index)">
                  <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                </el-popconfirm>
              </span>
              <span class="ele-action">
                <el-popconfirm title="确定要发送账号短信吗？" @onConfirm="sendParentMsg(row, $index)">
                  <el-link slot="reference" icon="el-icon-s-promotion" type="primary" :underline="false">发送账号短信</el-link>
                </el-popconfirm>
              </span>
            </div>
          </template>
        </el-table-column>
      </ele-data-table>
      <el-button @click="addParent" icon="el-icon-plus" style="width: 100%; margin-top: 15px">新增家长手机号</el-button>
      <div slot="footer" class="dialog-footer">
        <el-button @click="beforeClose">取 消</el-button>
        <el-button type="primary" @click="beforeClose">确 定</el-button>
      </div>
    </el-dialog>
    <!--调班弹窗-->
    <el-dialog title="调班" :visible.sync="changeClassDialog" width="30%" :destroy-on-close="true" :lock-scroll="false" :close-on-click-modal="false">
      <el-form ref="changeClassForm" :model="changeClassForm" label-width="80px">
        <el-row :gutter="15">
          <el-col>
            <el-form-item label="选择班级" prop="classId">
              <treeselect
                v-model="changeClassForm.classId"
                :options="ClassTree"
                :disable-branch-nodes="true"
                placeholder="请选择班级"
                :defaultExpandLevel="1"
                style="line-height: 20px"
                :normalizer="normalizer"
                noChildrenText="暂无数据"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="changeClassDialog = false">取消</el-button>
        <el-button type="primary" @click="changeClass">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import {
    saveStudent,
    updateStudent,
    deleteStudent,
    deleteStudents,
    getParentsByStudentId,
    saveParentsByStudentId,
    deleteParentIds,
    updateParent,
    changeStudentClass,
    findBranchTreeNameByClassId,
    sendAccountMsg,
  } from '@/config/api';

  export default {
    name: 'StudentList',
    components: { Treeselect },
    data() {
      return {
        table: {
          // 表格配置
          url: '/student/getClassStudentList',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        studentMobileTable: {
          page: false,
        },
        choose: [], // 表格选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          studentName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        },
        showStudentMobile: false, //家长学生手机号弹窗是否显示
        studentMobileData: [], //家长学生手机号数据
        // current:[], //家长学生选中数据
        addMobile: false, //显示添加手机号弹窗
        mobileForm: {}, // 表单数据
        mobileRules: {
          mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
          parentType: [{ required: true, message: '请选择亲属关系', trigger: 'change' }],
          netType: [{ required: true, message: '请选择手机网络类型', trigger: 'blur' }],
          netLocal: [{ required: true, message: '请选择是否本地号码', trigger: 'blur' }],
        },
        editParent: {},
        editIndex: null,
        studentId: null,
        editType: 1,
        classId: null,
        changeClassForm: {},
        ClassTree: [], //班级树
        changeClassDialog: false,
        normalizer(node) {
          if (node.orgType == 4) {
            if (node.children === null || node.children === [] || node.children === undefined) {
              delete node.children;
            }
          }
          return {
            id: node.id,
            label: node.name,
          };
        },
        title: '',
      };
    },
    mounted() {},
    methods: {
      add() {
        if (this.classId == null) return this.$message.error('请选择班级');
        this.showEdit = true;
      },
      /* 显示编辑 */
      edit(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      /* 保存编辑 */
      save(userId) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (userId == undefined) {
              //添加角色
              formData.append('classId', this.table.where.classId);
              saveStudent(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            } else {
              //编辑角色
              formData.delete('avatar');
              formData.append('classId', this.table.where.classId);
              formData.delete('state');
              updateStudent(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            }
          } else {
            return false;
          }
        });
      },
      /* 删除 */
      remove(row) {
        if (!row) {
          // 批量删除
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          let ids = this.choose.map((d) => d.id);
          this.$confirm('确定要删除选中的用户吗?', '提示', { type: 'warning' })
            .then(() => {
              const loading = this.$loading({ lock: true });
              let formData = new FormData();
              formData.append('ids', ids);
              formData.append('state', -1);
              deleteStudents(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            })
            .catch(() => 0);
        } else {
          // 单个删除
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('id', row.id);
          formData.append('state', -1);
          deleteStudent(formData)
            .then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        }
      },
      /* 更改状态 */
      // editState(row) {
      //   const loading = this.$loading({lock: true});
      //   let formData = new FormData();
      //   formData.append("id", row.id);
      //   formData.append("state", row.state);
      //   deleteStudent(formData).then((res) => {
      //     loading.close();
      //     if (res.data.resCode == 200) {
      //       this.$message({type: 'success', message: res.data.resMsg});
      //       this.$refs.table.reload();
      //     } else {
      //       row.state = !row.state ? 1 : 2;
      //       this.$message.error(res.data.resMsg);
      //     }
      //   }).catch(e =>{
      //     loading.close();
      //     this.$message.error(e.message);
      //   })
      // },
      /* 打开学生家长手机号列表弹窗 */
      studentMobileDialog(row) {
        this.showStudentMobile = true;
        this.getStudentMobile(row.id);
        this.studentId = row.id;
      },
      // 获取学生家长手机号
      getStudentMobile(id) {
        let data = {
          studentid: id,
        };
        getParentsByStudentId(data).then((res) => {
          if (res.data.resCode == 200) {
            this.studentMobileData = res.data.data;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      //添加学生家长手机号
      addParent() {
        this.editType = 1;
        if (this.studentMobileData.length == 0) {
          this.studentMobileData.push({ __is_add: true });
          this.editParent = {};
          this.editIndex = 0;
        }
        if (this.studentMobileData[this.studentMobileData.length - 1].__is_add) return;
        this.studentMobileData.push({ __is_add: true });
        this.editParent = {};
        this.editIndex = this.studentMobileData.length - 1;
      },
      // 取消编辑
      onCancelParent(row, index) {
        if (row.__is_add) this.studentMobileData.splice(index, 1);
        this.editIndex = null;
        this.editParent = {};
      },
      // 保存编辑
      onSaveParent(row, index) {
        if (!this.editParent.familyRelation) return this.$message.error('请选择亲属关系');
        if (!this.editParent.mobile) return this.$message.error('请输入手机号');
        if (!this.editParent.netType) return this.$message.error('请选择运营商');
        if (this.editParent.netLocal == undefined) return this.$message.error('请选择是否为本地号码');
        let data = new FormData();
        for (let key in this.editParent) {
          if (this.editParent[key] !== null && this.editParent[key] !== undefined) {
            data.append(key, this.editParent[key]);
          }
        }
        data.append('studentId', this.studentId);
        if (this.editType == 1) {
          //添加
          saveParentsByStudentId(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.getStudentMobile(this.studentId);
              this.studentMobileData[index] = Object.assign({}, this.editParent, {
                __is_add: false,
              });
              this.editIndex = null;
              this.editParent = {};
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        } else {
          //修改
          updateParent(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.studentMobileData[index] = Object.assign({}, this.editParent, {
                __is_add: false,
              });
              this.editIndex = null;
              this.editParent = {};
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        }
      },
      // 修改行
      onEditParent(row, index) {
        this.editType = 2;
        this.editIndex = index;
        this.editParent = Object.assign({}, row);
      },
      /* 删除行 */
      onRemoveParent(row, index) {
        this.studentMobileData.splice(index, 1);
        let data = new FormData();
        data.append('ids', row.id);
        data.append('state', '-1');
        deleteParentIds(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 家长手机号弹窗 关闭前
      beforeClose() {
        if (this.editIndex != null) {
          this.$message.error('请先保存家长手机号！');
        } else {
          this.showStudentMobile = false;
        }
      },
      showChangeClass(row) {
        if (!row) {
          //批量调班
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          this.changeClassDialog = true;
        } else {
          //单个调班
          this.changeClassDialog = true;
        }
      },
      // 调班
      changeClass() {
        let ids = this.choose.map((d) => d.id);
        let formData = new FormData();
        for (let key in this.changeClassForm) {
          if (this.changeClassForm[key] !== null && this.changeClassForm[key] !== undefined) {
            formData.append(key, this.changeClassForm[key]);
          }
        }
        formData.append('studentIds', ids);
        formData.set('classId', this.changeClassForm.classId.slice(1));
        changeStudentClass(formData).then((res) => {
          this.changeClassDialog = false;
          if (res.data.resCode == 200) {
            this.$message({
              type: 'success',
              dangerouslyUseHTMLString: true,
              message: res.data.resMsg,
              duration: 0,
              showClose: true,
            });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      //获取学校名字
      queryClassName(classId) {
        let data = {
          classId: classId,
        };
        findBranchTreeNameByClassId(data).then((res) => {
          if (res.data.resCode == 200) {
            this.title = res.data.data;
          }
        });
      },
      // 发送账号短信
      sendParentMsg(row) {
        let parentId = row.id;
        console.log(row);
        sendAccountMsg({ id: parentId }).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已发送' });
          }
        });
      },
    },
  };
</script>

<style scoped></style>
